import { Component, OnInit, ViewChild } from "@angular/core";
import { moduleType } from "../../shared/models/module.type";
import { language } from "../../shared/models/language.model";
import { TranslationService } from "../../shared/services/translation/translation.service";
import { QuoterRequest2Service } from "../../shared/services/quote-request/quote-request2.service";
import { GeneralComponent } from "../../components/general/general.component";
import { QuestionsComponent } from "../../components/questions/questions.component";
import { ImageService } from "../../shared/services/images/image.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { QuoteStorageService } from "../../shared/services/quote-storage/quote-storage.service";
import { SessionService } from "../../shared/services/session/session.service";
import { ProductSpotlightComponent } from "src/app/components/product-spotlight/product-spotlight.component";

@Component({
    selector: "app-mobilehome",
    templateUrl: "./mobilehome.component.html",
    styleUrls: ["./mobilehome.component.scss"],
    standalone: false
})
export class MobilehomeComponent implements OnInit {
    @ViewChild(GeneralComponent) general: GeneralComponent;
    @ViewChild(QuestionsComponent) questions: QuestionsComponent;
    @ViewChild(ProductSpotlightComponent) productSpotlight: ProductSpotlightComponent;
    policytype = moduleType.mobilehome;
    lang = language;
    showQuestions = false;
    isComparePage: boolean;
    yesCompare = false;

    constructor(
        private route: ActivatedRoute,
        public translationService: TranslationService,
        private quoterRequestService: QuoterRequest2Service,
        private translate: TranslateService,
        private quoteStorageService: QuoteStorageService,
        private sessionService: SessionService,
        private imageService: ImageService,
        private router: Router) {

        //need to know which route/view to save/restore
        const url = "/mobilehome/" + (this.route.snapshot.routeConfig.path.endsWith("/details") ? "details" : "general");
        this.sessionService.listenUnload(url, function () {
            this.quoteStorageService.SaveState(this.sessionService.getRelativeUrl())
                .SaveRequest(this.quoterRequestService.getCurrentQuoterRequest())
                .SaveLanguage(this.translationService.currentLanguage);
        }.bind(this));
    }

    ngOnInit(): void {
        if (this.route.snapshot.queryParams['showGeneralPage'])
        {
            const showQuestions = this.route.snapshot.queryParams['showGeneralPage'] === "true";
            const reset = this.route.snapshot.queryParams['reset'] === "true";
            this.showQuestions = (showQuestions || reset);
            this.isComparePage = (showQuestions || reset);
            this.yesCompare = this.parseYesCompare(this.route.snapshot.queryParams['yesCompare']);
        }

        if (this.route.snapshot.routeConfig.path.endsWith("/details"))
        {
            this.showQuestions = true;
            this.isComparePage = true;
        }

        /*
        if (this.route.snapshot.queryParams['showGeneralPage'] || this.route.snapshot.routeConfig.path.endsWith("/details")) {
            const showQuestions = this.route.snapshot.queryParams['showGeneralPage'] === "true" || this.route.snapshot.routeConfig.path.endsWith("/details");
            const reset = this.route.snapshot.queryParams['reset'] === "true";
            this.showQuestions = (showQuestions || reset);
            this.isComparePage = (showQuestions || reset);
            this.yesCompare = this.parseYesCompare(this.route.snapshot.queryParams['yesCompare']);
        }
        */
        this.quoterRequestService.setSettingForQuestionPage(this.quoterRequestService.getCurrentQuoterRequest());

        this.translationService.onLangChange.subscribe((event: any) => {
            if (this.general) {
                this.general.languageChanged();
            }
        });
    }

    parseYesCompare(input: any) {
        if (input === 'true') {
            return true;
        }

        if (input === 'false') {
            return false;
        }

        return undefined;
    }

    useLanguage(selectedlanguage: string) {
        this.translationService.useLanguage(selectedlanguage);
        this.quoteStorageService.SaveLanguage(this.translationService.currentLanguage);
    }

    goToQuestionPage($event: any) {
        if ($event === "true") {
            this.router.navigate(["mobilehome/details"]);
            this.showQuestions = true;
        }
    }

    goToGeneralPage($event: any) {
        if ($event === "true") {
            this.router.navigate(["mobilehome/general"]);
            this.showQuestions = false;
        }
    }

    headerTitle(): string {
        const calcInput = this.quoterRequestService.getCalcInputData();

        let title = this.translate.instant("MOBILEHOME.HEADER_TITLE");
        if (!calcInput) return title;
        if (!calcInput.PersonalPropertyDeductible) {
            title = this.translate.instant("GLOBAL.Mobilehome");
        }
        else if (calcInput.PersonalPropertyDeductible !== 0 &&
            calcInput.PersonalPropertyDeductible !== null) {
            title = this.translate.instant("GLOBAL.Mobilehome Choice");
        }

        return title;
    }

    imageUrl(relative: string) {
        return this.imageService.ImageLoc(relative);
    }

}
